import React from 'react'
import { Backdrop, Button, Popover, Typography } from '@mui/material'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import { useNavigate } from 'react-router-dom'
import useStyles from './_styles'
import HealthCareServicesList from '../healthCareServicesList/HealthCareServicesList'
import useCurrentHcs from '../../../hooks/useCurrentHcs'

const HeaderHcsSwitch = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    const healthCareService = useCurrentHcs()

    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleSelect = () => {
        handleClose()
        navigate('/', { replace: true })
    }

    const open = Boolean(anchorEl)
    const id = open ? 'HeaderHcsSwitch-popover' : undefined

    return (
        <>
            <Button className={classes.HeaderHcsSwitchButton} onClick={handleClick} data-cy="dataCy-hcsSwitchButton">
                <HomeRoundedIcon />
                <Typography className={classes.HeaderHcsSwitchButtonLabel}>{healthCareService.name}</Typography>
                <ArrowDropDownRoundedIcon />
            </Button>
            <Popover
                classes={{
                    paper: classes.HeaderHcsSwitchPaper,
                }}
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <HealthCareServicesList onCancel={handleClose} onSelect={handleSelect} closeButtonText="Fermer" />
            </Popover>
            <Backdrop className={classes.HeaderHcsSwitchBackdrop} open={open} onClick={handleClose} />
        </>
    )
}

export default HeaderHcsSwitch
